// no-op: Sentry removed, logging now handled by Better Stack Vercel integration
